import React from 'react'

const Radio = ({ attribute, state, onChange }) => {
  const { key, name, options, disabled } = attribute

  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-gray-600 uppercase tracking-wider">
        { name }
      </p>

      <div className='flex'>
        { options.map(({ value, label }, i) => (
          <div key={value} className="relative p-2 flex cursor-pointer hover:bg-blue-100" onClick={() => onChange(value)}>
            <div className="flex items-center h-5">
              <input
                type="radio"
                name={`radio-${key}-${i}`}
                className="focus:ring-primary h-4 w-4 text-primary-darker cursor-pointer border-gray-300"
                checked={state == value}
                disabled={disabled}
                value={value}
              />
            </div>

            <label htmlFor={`radio-${key}-${i}`} className="ml-3 flex flex-col cursor-pointer">
              <span className={`${state == value ? 'text-primary' : 'text-gray-900'} block text-sm font-medium`}>
                { label }
              </span>
            </label>
          </div>
        )) }
      </div>

    </div>
  )
}

export default Radio
